// ListBilling.jsx
import React from "react";
import { Table, Message, Icon } from "semantic-ui-react";
import { size, map } from "lodash";
import { useTranslation } from "react-i18next";
import { BillingItem } from "../ItemBilling/BillingItem";

export function ListBilling(props) {
  const { billings, isPartner } = props;
  const { t } = useTranslation("billing");

  // Si aún no cargó o es null, no renderiza nada
  if (!billings) return null;

  // Si no hay facturas, mostramos un mensaje centrado
  if (size(billings) === 0) {
    return (
      <Message icon info style={{ marginTop: "2em", textAlign: "center" }}>
        <Icon name="file alternate outline" />
        <Message.Content>
          <Message.Header>{t("list.noInvoices")}</Message.Header>
          {t("list.noInvoicesContent")}
        </Message.Content>
      </Message>
    );
  }

  return (
    <Table compact celled className="list-billing">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t("list.clientHeader")}</Table.HeaderCell>
          <Table.HeaderCell>{t("list.contactHeader")}</Table.HeaderCell>
          <Table.HeaderCell>{t("list.numberHeader")}</Table.HeaderCell>
          <Table.HeaderCell>{t("list.descriptionHeader")}</Table.HeaderCell>
          <Table.HeaderCell>{t("list.totalHeader")}</Table.HeaderCell>
          {isPartner && (
            <Table.HeaderCell>{t("list.commissionHeader")}</Table.HeaderCell>
          )}
          <Table.HeaderCell>{t("list.statusHeader")}</Table.HeaderCell>
          <Table.HeaderCell>{t("list.clientInvoiceHeader")}</Table.HeaderCell>
          {isPartner && (
            <Table.HeaderCell>
              {t("list.providerInvoiceHeader")}
            </Table.HeaderCell>
          )}
          <Table.HeaderCell>{t("list.dateHeader")}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {map(billings, (billing) => (
          <BillingItem
            key={billing._id}
            billing={billing}
            isPartner={isPartner}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
